import React from "react";
import { Info } from "lucide-react";
import { T } from "../../app/tokens.js";

// Future Projects adoption can explain Completed projects hidden by the default
// filter, using its own eligible candidate set and filter-only reveal callback.
export function FilterHiddenSearchHint({ hint, entity, onClear, empty = false }) {
  if (!hint || !(hint.count > 0) || !hint.query?.trim()) return null;
  const singular = hint.count === 1;
  return (
    <div role="status" data-testid="filter-hidden-search-hint" style={{
      display: "flex", alignItems: "baseline", gap: 8,
      padding: "2px 4px", background: "none", border: 0,
      borderRadius: 0, boxShadow: "none", color: T.mid,
      fontSize: T.fsSm5, lineHeight: 1.45,
    }}>
      <Info size={15} aria-hidden="true" style={{ flexShrink: 0, alignSelf: "center", color: T.blue }} />
      <span style={{ minWidth: 0, overflowWrap: "anywhere" }}>
        {empty ? (
          `No ${entity}s match within your current filters — but ${hint.count} ${singular ? "matches" : "match"} "${hint.query}" outside them.`
        ) : (
          <>
            <strong style={{ color: T.dark, fontWeight: T.fwSemibold }}>
              {hint.count} more {entity}{singular ? "" : "s"}
            </strong>
            {` ${singular ? "matches" : "match"} "${hint.query}" but ${singular ? "is" : "are"} hidden by the active filter.`}
          </>
        )}
        {" "}
        <button type="button" onClick={onClear}
          onMouseEnter={(event) => { event.currentTarget.style.textDecoration = "underline"; }}
          onMouseLeave={(event) => { event.currentTarget.style.textDecoration = "none"; }}
          style={{
            border: 0, background: "none", padding: 0, marginLeft: 8, color: T.blue,
            font: "inherit", fontWeight: T.fwSemibold, cursor: "pointer",
            whiteSpace: "nowrap", textDecoration: "none", textUnderlineOffset: 2,
          }}>Clear filter to view</button>
      </span>
    </div>
  );
}
